import './BrandingCard.scss'

import React, { Component } from 'react'
import { Image } from 'react-bootstrap'

class BrandingCard extends Component {

    constructor(props) {
        super(props)
    }

    websiteBlock() {
      const {website_name, website_url} = this.props;
      if (!website_name) {
        return <div className="BrandingCard__website" />;
      }

      if (!website_url) {
        return <div className="BrandingCard__website">{website_name}</div>
      }

      return <div className="BrandingCard__website"><a href={website_url}>{website_name}</a></div>
    }

    render() {
        return (
            <div className="BrandingCard__container">
                {
                    this.props.cropMode ?
                        <div className="BrandingCard__img-preview"/>
                        : <Image src={this.props.logo} className="BrandingCard__logo"/>
                }
                <div className="BrandingCard__text-info">
                    <div className="BrandingCard__company">{this.props.company}</div>
                    {this.websiteBlock()}
                </div>
            </div>
        )
    }
}

export default BrandingCard
